import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicPaidRegistrationForm from '../LandingPage/components/PublicPaidRegistrationForm';
import '../LandingPage/LandingPage.css';

export default function PublicTeamRegistrationPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-container" style={{ minHeight: '100vh', padding: '1.5rem 1rem 2rem' }}>
      <div style={{ maxWidth: 980, margin: '0 auto 1rem' }}>
        <button type="button" className="deep-dive" onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>
      <PublicPaidRegistrationForm />
    </div>
  );
}
